'use client'

import { version } from '../../package.json'

const GRAPHQL_URL = 'https://graphql.aws.mapquest.com'

/**
 * Fetch the viewer's approximate location based on IP address
 * @returns {Promise<[number, number] | null>} [longitude, latitude] or null
 */
export async function fetchViewerLocation () {
  try {
    const { data } = await fetch(GRAPHQL_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-GraphQL-Client-Name': 'embed',
        'X-GraphQL-Client-Version': version,
      },
      body: JSON.stringify({
        query: `
          query ViewerLocation {
            viewer {
              location {
                coordinates {
                  latitude
                  longitude
                }
              }
            }
          }
        `,
      }),
    }).then(res => res.json())

    const { latitude, longitude } = data?.viewer?.location?.coordinates || {}

    if (latitude != null && longitude != null) {
      return [longitude, latitude]
    }

    return null
  } catch (error) {
    console.error('Failed to fetch viewer location:', error)
    return null
  }
}
